import React, { useState } from 'react';
import Dashboard from './pages/Dashboard';
import Chat from './pages/Chat';
import GOATMode from './pages/GOATMode';
import EraComparison from './pages/EraComparison';
import Simulate from './pages/Simulate';

const NAV_ITEMS = ['Dashboard', 'Chat', 'GOAT Mode', 'Simulate', 'Era Comparison'];

const App: React.FC = () => {
  const [activePage, setActivePage] = useState('Dashboard');

  const renderPage = () => {
    switch (activePage) {
      case 'Chat':           return <Chat />;
      case 'GOAT Mode':      return <GOATMode />;
      case 'Simulate':       return <Simulate />;
      case 'Era Comparison': return <EraComparison />;
      default:               return <Dashboard />;
    }
  };

  return (
    <div style={{ background: '#0D0F14', minHeight: '100vh', fontFamily: 'Georgia, serif' }}>
      <nav style={{
        background: '#13161D',
        borderBottom: '0.5px solid rgba(255,255,255,0.08)',
        display: 'flex', alignItems: 'center',
        padding: '0 16px', height: '48px', gap: '16px'
      }}>
        <span style={{
          color: '#F5820A', fontFamily: 'Courier New', fontSize: '15px',
          fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase'
        }}>◉ HoopsIQ</span>

        <div style={{ display: 'flex', gap: '4px', flex: 1 }}>
          {NAV_ITEMS.map(item => (
            <button key={item} onClick={() => setActivePage(item)} style={{
              fontFamily: 'sans-serif', fontSize: '12px',
              padding: '5px 12px', borderRadius: '6px', border: 'none', cursor: 'pointer',
              background: activePage === item ? 'rgba(245,130,10,0.12)' : 'transparent',
              color: activePage === item ? '#F5820A' : '#8892A4',
              transition: 'all 0.15s'
            }}>{item}</button>
          ))}
        </div>

        <span style={{
          fontFamily: 'Courier New', fontSize: '10px', letterSpacing: '0.1em',
          background: 'linear-gradient(135deg, #C9A84C, #F5820A)',
          color: '#000', padding: '3px 10px', borderRadius: '20px', fontWeight: 700
        }}>PRO</span>
      </nav>

      {renderPage()}
    </div>
  );
};

export default App;
